/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MoneyTypeCardIcon20Light = forwardRef('MoneyTypeCardIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M12 7.5a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 0-1h-2a.5.5 0 0 0-.5.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 7a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7Zm1 5v1a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-1H3Zm14-1H3V7a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v4Z" })));
});
